import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from '@material-ui/core/Select';

import { makeStyles } from 'utils';
import classNames from './Refiner.module.css';
import { selectorShape } from './Refiner.props';

const blankValue = 'Y2M5NzAzNWEtNGRjYy00Nzc2LTk3ODYtZGVmZjZlOTFjMjE4';
const styles = makeStyles(classNames);

function RefinerNumberSelectField({
    idBase,
    readOnly,
    selector,
    uniqueFieldValues,
    value,
    onChange
}) {
    const { error, allowEmpty } = selector;
    const uniqueNumbers = useMemo(() => uniqueFieldValues
        .map(v => parseInt(v))
        .filter(v => !isNaN(v))
        .sort((a, b) => a - b), [uniqueFieldValues]);

    const handleCheckboxChange = useCallback(e => {
        onChange({
            target: {
                value: {
                    ...value,
                    andAbove: e.target.checked
                }
            }
        });
    }, [onChange, value]);

    const handleSelectChange = useCallback(e => {
        onChange({
            target: {
                value: {
                    ...value,
                    selectedValue: e.target.value
                }
            }
        });
    }, [onChange, value]);

    return (
        <>
            <FormControl error={!!(error)} className={styles('row__form-control')}>
                <InputLabel id={idBase + '_value-label'} htmlFor={idBase + '_value'}>Value</InputLabel>
                <Select
                    id={idBase + '_value'}
                    className={styles('row__input')}
                    disabled={readOnly}
                    value={value?.selectedValue || ''}
                    onChange={handleSelectChange}
                >
                    {uniqueNumbers.map((val) => (
                        <MenuItem key={val} value={String(val)}>
                            {val}
                        </MenuItem>
                    ))}
                    {uniqueFieldValues.hasEmptyValues && allowEmpty && (
                        <MenuItem key={blankValue} value={blankValue} className={styles('row__menu-item--empty')}>Not Set</MenuItem>
                    )}
                </Select>
                {error && (<FormHelperText>{error}</FormHelperText>)}
            </FormControl>
            {value && uniqueNumbers.length > 0 && value.selectedValue !== String(uniqueNumbers[uniqueNumbers.length - 1]) && (
                <FormControlLabel
                    className={styles('row__inline-checkbox')}
                    control={
                        <Checkbox
                            checked={value?.andAbove || false}
                            onChange={handleCheckboxChange}
                        />
                    }
                    label="And Above"
                />
            )}
        </>
    );
}

RefinerNumberSelectField.propTypes = {
    idBase: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    selector: PropTypes.shape(selectorShape).isRequired,
    uniqueFieldValues: PropTypes.arrayOf(PropTypes.string).isRequired,
    value: PropTypes.object,
    onChange: PropTypes.func.isRequired,
};

export default RefinerNumberSelectField